<!-- Payment.vue -->
<template>
    <div style="width: 100%;">
      <div class="modal fade" id="mdfimd" role="dialog" aria-hidden="true" data-backdrop="static">
            <div class="modal-dialog modal-xl modal-dialog-centered" role="document">
                <div class="modal-content">
                    <div class="modal-body text-justify">
                        <div class="jumbotron" style="margin-bottom: 0px;">
                            <div class="container-fluid">
                                <div class="row"> 
                                  <div class="col-md-12 text-center">
                                       utilize esse QR code para pagar sua fatura via PIX(esse codigo expira em 1 hora)  
                                  </div>
                                  <div class="col-md-12 text-center">
                                    <div style="display: flex; justify-content: center; padding-top: 60px;">
                                       <img style="width: 150px;" :src="qrcode">                                            
                                       
                                    </div>
                                 
                                  </div>
                                  <div style="  padding-top: 30px;" class="col-md-12 text-center">
                                    Total a pagar
                                  <p style="    color: blueviolet;
                                          font-size: 16px;
                                       
                       
                                          font-weight: 900;">R$ {{  mtdformatavalordecimal(parseFloat(valorexibir), 2) }}</p>
                                  </div>

                                  <div style="padding-top: 10px;" class="col-md-12 text-center">
                                    <p style="    color: blueviolet;
                                          font-size: 10px;
                                       
                       
                                          font-weight: 900;">{{ copiacola }}</p>
                                  </div>
                                  <div class="col-md-12 text-center">
                                        <a href="#" class="btn btn-success" @click.prevent="copiarcodigo()">Copiar codigo</a>
                                  </div>  
                                 
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div> 
    </div>
  </template>
  
  <script>
   import util from '../utilitarios/util.js'
  export default {
    data: function () {
      return {
        qrcode      : '',
        copiacola   : '',
        valorexibir : 0,
        codtit      : ''  

      }
    },
    computed: {
      paymentType() {
        return this.$route.params.type;
      }
    },
    mounted(){
      var op = ''
      if(this.paymentType == 'first'){
          op = 'imediato'   
      }else{
          op = 'vencimento'  
      }   

      let vself  = this; 
      let idclisac = vself.$store.state.filialpadrao.idcliente !== null ? vself.$store.state.filialpadrao.idcliente : window.localStorage.getItem('idcliente');
      if (idclisac !== null){                
          let loader = vself.$loading.show();
          let parametros      = [
              {parametro: 'opbanco',          valor : op},
              {parametro: 'idcliente',        valor : idclisac}//id do cliente no sac
          ];
          let retorno     = util.reqaxios(parametros, 'post', 'dracosys.top/gerencia/controller/rotinacobrancaefi.php');
          retorno.then(function (response) {
              loader.hide();
              if($.isNumeric(response.data.ret)){
                vself.qrcode      = response.data.qrcode;
                vself.copiacola   = response.data.copiacola;
                vself.valorexibir = response.data.valorexibir;
                vself.codtit      = response.data.codtit;
                
                
                $('#mdfimd').modal('show');
                vself.consultastatus();

              }else{
                vself.$toastr.w(response.data.ret, 'Atenção!');
              }
            
             
          }).catch(function (response) {
              loader.hide();                     
          });   
        }
    },
    methods: {
      mtdvoltarprincipal(){
        this.$router.push({ name: 'principal' });
      },
      mtdformatavalordecimal(valor, digitos){
				return util.formatavalordecimais(valor, digitos);
			},  
      copiarcodigo() {
        const textToCopy = this.copiacola;
        // Cria um elemento de texto temporário para segurar o conteúdo a ser copiado
        const tempInput = document.createElement('textarea');
        tempInput.value = textToCopy;
        document.body.appendChild(tempInput);
        tempInput.select();
        try {
          // Executa o comando de cópia
          document.execCommand('copy');
          this.$toastr.s('Copiado para área de transferência', 'Atenção!');
         
        } catch (err) {
          console.error('Falha ao copiar o texto: ', err);
        }
        // Remove o elemento de texto temporário
        document.body.removeChild(tempInput);
      },
      consultastatus(){
        let vself  = this; 
       const intervalid = setInterval(() => {
          
      let idclisac = vself.$store.state.filialpadrao.idcliente !== null ? vself.$store.state.filialpadrao.idcliente : window.localStorage.getItem('idcliente');
      if (idclisac !== null){                
         
          let parametros      = [
              {parametro: 'opbanco',          valor : 'consulta'},
              {parametro: 'codtit',           valor : vself.codtit},
              {parametro: 'idcliente',        valor : idclisac}//id do cliente no sac
          ];
          let retorno     = util.reqaxios(parametros, 'post', 'dracosys.top/gerencia/controller/rotinacobrancaefi.php');
          retorno.then(function (response) {
            if($.isNumeric(response.data)){
              if(parseInt(response.data)=== 1){

                $.confirm({
                    title: 'Confirmação de pagamento!',
                    content: 'Seu pagamento foi detectado com sucesso!',
                    icon: 'fa fa-check',
                    escapeKey: true,
                    backgroundDismiss: false,
                    escapeKey: 'nao',
                    type: 'dark',
                    typeAnimated: true,
                    buttons: {
                        sim: {
                            text: '<u>O</u>K',
                            keys: ['s', 'S'],
                            btnClass: 'btn-blue',
                            action: function () {
                                
                                vself.mtdvoltarprincipal();
                            },
                        },
                   
                    }
                });

                clearInterval(intervalid);

              }
            }
      
            
             
          }).catch(function (response) {
                                
          }); 
        }  

        }, 2000);
      }
  }
  }
  </script>
  